module.exports = __webpack_public_path__ + "static/media/Rosine_desktop_article_7.3a3dadf9.jpg";